import React from "react";
import { createInertiaApp } from "@inertiajs/react";
import { createRoot } from "react-dom/client";

// Import all page components eagerly
// Add new pages here as you create them
import Home from "./pages/Home.jsx";

const pages = {
  Home,
};

createInertiaApp({
  resolve: (name) => {
    const page = pages[name];
    if (!page) {
      throw new Error(
        `Unknown page: ${name}. Did you forget to add it to the pages object in application.jsx?`
      );
    }
    return page;
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />);
  },
});
